import React from 'react';
import { Globe, Smartphone, Cloud, Palette, Rocket, Users, ArrowRight, Check } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Globe: Globe,
  Smartphone: Smartphone,
  Cloud: Cloud,
  Palette: Palette,
  Rocket: Rocket,
  Users: Users
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            Our Services
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#1e3a5f] leading-tight">
            End-to-End Digital Solutions
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            From ideation to deployment, we deliver comprehensive services tailored to your business needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Globe;
            return (
              <div
                key={service.id}
                className="group relative bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-2xl border border-transparent hover:border-[#f26522]/20 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-[#1e3a5f] flex items-center justify-center mb-6 group-hover:bg-[#f26522] transition-colors duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-[#1e3a5f] mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.shortDesc}
                </p>

                {/* Capabilities */}
                <div className="space-y-2 mb-6">
                  {service.capabilities.slice(0, 3).map((cap, i) => (
                    <div key={i} className="flex items-center text-sm text-gray-500">
                      <Check className="w-4 h-4 text-[#f26522] mr-2 flex-shrink-0" />
                      {cap}
                    </div>
                  ))}
                </div>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {service.technologies.slice(0, 4).map((tech, i) => (
                    <span
                      key={i}
                      className="px-3 py-1 text-xs font-medium bg-[#1e3a5f]/10 text-[#1e3a5f] rounded-full"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <button className="flex items-center text-[#f26522] font-medium hover:text-[#d95a1b] transition-colors group/btn">
                  {service.cta}
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
